import React from "react";
import { motion } from "framer-motion"; // Import motion from framer-motion
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
} from "@chakra-ui/react";

const glassmorphismStyle = {
  backdropFilter: "blur(16px) saturate(180%)",
  WebkitBackdropFilter: "blur(16px) saturate(180%)",
  backgroundColor: "rgba(17, 25, 40, 0.75)",
  borderRadius: "0px",
  border: "1px solid rgba(255, 255, 255, 0.125)",
  color: "rgba(255, 255, 255, 0.95)",
};

export const ErrorAlert = () => (
  <motion.div
    initial={{ opacity: 0 }} // Initial state (hidden)
    animate={{ opacity: 1 }} // Animation state (visible)
    exit={{ opacity: 0 }} // Exit state (hidden)
  >
    <Alert
      status="error"
      borderRadius="0px"
      boxShadow="md"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="260px"
      padding="20px"
      sx={glassmorphismStyle}
    >
      <Box marginBottom="10px">
        <AlertIcon boxSize="40px" color="white" />
      </Box>
      <AlertTitle
        fontWeight="bold"
        fontSize="xl"
        marginBottom="8px"
        color="white"
      >
        Cannot Find Position Request
      </AlertTitle>
      <AlertDescription
        maxWidth="sm"
        marginBottom="16px"
        color="gray.300"
        fontSize="md"
      >
        There was an error in finding the request. Please try again or contact
        Process Improvement.
      </AlertDescription>
    </Alert>
  </motion.div>
);
